import React, { FC, JSX } from 'react';
import './row.css';

interface RowInterface {
  children: JSX.Element;
  resuablelineTable?: boolean;
}

const Row: FC<RowInterface> = ({ children, resuablelineTable }) => {
  return (
    <div
      className={`linetable-sr-def-row linetable-sr-responsive-row
      ${resuablelineTable && 'resusable-linetable'}
      `}
    >
      {children}
    </div>
  );
};
export default Row;
